module.exports = __webpack_public_path__ + "static/media/DownWhite.b9095435.svg";